export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-500">有建议或资源推荐？欢迎与我们取得联系</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/40">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-600 mb-1">投稿邮箱</p>
                <p className="text-sm text-foreground-300 font-medium">contact@51cinema.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                  <i className="ri-chat-3-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-600 mb-1">意见反馈</p>
                <p className="text-sm text-foreground-300 font-medium">feedback@51cinema.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                  <i className="ri-links-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-600 mb-1">资源合作</p>
                <p className="text-sm text-foreground-300 font-medium">partner@51cinema.com</p>
              </div>
            </div>

            <p className="text-sm text-foreground-500 text-center leading-relaxed">
              如果您有优质影视资源推荐、站点合作意向或功能改进建议，欢迎通过以上方式联系我们。我们的运营团队将尽快回复您的来信。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}